import ddmmyyyy from 'ddmmyyyy'

const parser = {
  'DD/MM/YYYY': ddmmyyyy(/^(\d\d)\/(\d\d)\/(\d\d\d\d)$/, 'dmy'),
  'MM/DD/YYYY': ddmmyyyy(/^(\d\d)\/(\d\d)\/(\d\d\d\d)$/, 'mdy'),
  'YYYY-MM-DD': ddmmyyyy(/^(\d\d\d\d)-(\d\d)-(\d\d)$/, 'ymd'),
}

export default function parse (value, format) {
  const formats = ['YYYY-MM-DD']
  if (format) formats.push(format)

  for (let i = 0; i < formats.length; i++) {
    const date = parser[formats[i]].parse(value)
    if (date) {
      return date
    }
  }
}
